import DefaultInput from "@View/components/formInputs/DefaultInput";
import ModalLayout from "@View/components/ModalLayout";
import React from "react";
import { formatDate } from "@Localization/utils";
import { IsWhiteLabel } from "@Constants/tokens";

const CustomerDetails = ({ customer, open, handleClose }) => {
  if (Object.keys(customer).length === 0) return <></>;

  return (
    <>
      <ModalLayout
        open={open}
        onClose={handleClose}
        title="h1.Details of"
        subtitle={customer.name}
      >
        <DefaultInput
          label="inputs.External Id"
          value={customer.externalId}
          onChange={() => null}
        />
        <DefaultInput
          value={customer?.status}
          label="inputs.Status"
          onChange={() => null}
        />
        <DefaultInput
          label="inputs.Email"
          value={customer.email}
          onChange={() => null}
        />
        <DefaultInput
          label="inputs.Create Date"
          value={formatDate(customer.createdAt)}
          onChange={() => null}
        />        
        <DefaultInput
          label="inputs.Updated At"
          value={formatDate(customer.updatedAt)}
          onChange={() => null}
        />
        {!IsWhiteLabel() && (
          <DefaultInput
            label="Requests left"
            value={String(customer.requestsLeft)}
            onChange={() => null}
          />
        )}
        <DefaultInput
          label="Total requests"
          value={String(customer.totalRequests)}
          onChange={() => null}
        />
        <DefaultInput
          label="inputs.defaultLanguage"
          value={customer.defaultLanguage}
          onChange={() => null}
        />
        <DefaultInput
          label="inputs.Subscription Until"
          value={formatDate(customer.subscriptionUntil)}
          onChange={() => null}
        />
        <DefaultInput
          label="inputs.Server url"
          value={customer.serverUrl}
          onChange={() => null}
        />
        <DefaultInput
          label="inputs.OneSPackageName"
          value={customer.oneSPackageName}
          onChange={() => null}
        />
      </ModalLayout>
    </>
  );
};

export default CustomerDetails;
